import {LOGIN_USERNAME_PASSWORD, SIGNUP, SOCIAL_CONNECTION, RECOVER_PASSWORD} from "./types";
import {loginError, handleLogin, signUpError, loginUsernamePassword} from './actions';
import {ALERT_OPEN} from "../../actions/actionTypes";
import {LOGIN_INVALID, REGISTER_INVALID, REGISTER_LOGIN_INVALID, REGISTER_CHANGE_PASSWORD, REGISTER_CHANGE_PASSWORD_ERROR} from "../../lang/alerts";

export default (auth0) => {

    return (store) => (next) => async (action) => {
        if (action.type === LOGIN_USERNAME_PASSWORD) {
            try {
                const authResult = await auth0.login(action.username, action.password, action.options);

                next(handleLogin(authResult));

                ////if (action.redirect) {
                ////  return store.dispatch(action.redirect);
                ////}

                return next(action);
            } catch (error) {
                if (action.options.from === 'register') {
                    store.dispatch({type: ALERT_OPEN, message: REGISTER_LOGIN_INVALID});
                    return next(loginError(error));
                }
                store.dispatch({type: ALERT_OPEN, message: LOGIN_INVALID});
                return next(loginError(error));
            }
        }

        if (action.type === SIGNUP) {
            try {
                const authResult = await auth0.signup(action.email, action.password, action.options);

                next(handleLogin(authResult));

                //if (action.redirect) {
                //  return store.dispatch(action.redirect);
                //}

                return next(action);

            } catch (error) {
                //If SignUp fails because user exists we try to login using the user/password combination

                if (error.code === 'user_exists') {

                    return store.dispatch(loginUsernamePassword({
                        username: action.email,
                        password: action.password,
                        realm: process.env.REACT_APP_AUTH0_CONNECTION,
                        from: 'register',
                    }));
                }
                store.dispatch({type: ALERT_OPEN, message: REGISTER_INVALID});
                return next(signUpError(error));
            }
        }

        if (action.type === SOCIAL_CONNECTION) {
            return auth0.socialConnection(action.options);
        }

        if (action.type === RECOVER_PASSWORD) {
            try {
                auth0.recoverPassword(action.email, action.options);
                store.dispatch({ type: ALERT_OPEN, message: REGISTER_CHANGE_PASSWORD });
            } catch (error) {
                store.dispatch({ type: ALERT_OPEN, message: REGISTER_CHANGE_PASSWORD_ERROR });
            }
        }

        return next(action);
    };
};
